import React, { useState } from "react";

// Clap4Service.jsx
// Mobile-first, dark-theme (pink accent) React component using Tailwind CSS classes.
// Dummy data included. Default export a React component.

export default function Clap4Service() {
  const tabs = [
    { id: "beauty", label: "Beauty" },
    { id: "revamp", label: "Revamp" },
    { id: "native", label: "Native" },
  ];

  const neighbourhoods = [
    "Palava",
    "MG Road",
    "Koramangala",
    "Andheri",
    "Gariahat",
    "Civil Lines",
    "Select your neighbourhood",
  ];

  const services = {
    beauty: [
      { id: 1, name: "Haircut & Styling", short: "In-home haircut & styling", emoji: "💇‍♀️" },
      { id: 2, name: "Facial & Skin Care", short: "Detox & glow facial at home", emoji: "💆‍♀️" },
      { id: 3, name: "Manicure & Pedicure", short: "Nail care at your doorstep", emoji: "💅" },
      { id: 4, name: "Makeup", short: "Occasion & party makeup", emoji: "💄" },
    ],
    revamp: [
      { id: 11, name: "Home Painting", short: "Quick refresh / full repaint", emoji: "🎨" },
      { id: 12, name: "Modular Kitchen", short: "Fixes & minor refit", emoji: "🔧" },
      { id: 13, name: "Electrical Revamp", short: "Rewiring & fixtures", emoji: "💡" },
      { id: 14, name: "Bathroom Retrofit", short: "Pipes, fittings & tiles", emoji: "🚿" },
    ],
    native: [
      { id: 21, name: "Local Tutors", short: "Tuition & skill classes", emoji: "📚" },
      { id: 22, name: "Fitness Coach", short: "Yoga / PT at home", emoji: "🏋️‍♀️" },
      { id: 23, name: "Pet Care", short: "Grooming & walking", emoji: "🐶" },
      { id: 24, name: "Grocery Assist", short: "Local errand help", emoji: "🛒" },
    ],
  };

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [neighbour, setNeighbour] = useState(neighbourhoods[5]);
  const [query, setQuery] = useState("");

  const activeServices = services[activeTab] || [];

  return (
    <div className="min-h-screen bg-neutral-900 text-neutral-100 p-4 sm:p-2">
      <div className="mx-auto">
        {/* Card */}
        <div className="rounded-2xl bg-gradient-to-br from-neutral-900 via-pink-900/30 to-neutral-800/20 ring-1 ring-pink-700/20 shadow-lg overflow-hidden">
          <header className="p-4 border-b border-pink-700/10">
            {/* <div className="flex items-center justify-between"> */}
              <div className="flex flex-col items-center">
                <h1 className="text-xl font-semibold tracking-tight">Clap4Service</h1>
                <p className="text-sm text-pink-300/80">Services at your doorstep — fast & trusted</p>
              </div>
              {/* <div className="text-pink-300 text-sm font-medium">Dark • Pink</div> */}
            {/* </div> */}

            {/* neighbourhood dropdown (mobile-first) */}
            <div className="mt-4">
              <label className="sr-only">Neighbourhood</label>
              <select
                aria-label="Select neighbourhood"
                value={neighbour}
                onChange={(e) => setNeighbour(e.target.value)}
                className="w-full h-10 bg-neutral-800 text-neutral-100 rounded-lg py-2 px-3 border border-pink-700/20 focus:outline-none focus:ring-2 focus:ring-pink-400/30"
              >
                {neighbourhoods.map((n, idx) => (
                  <option key={idx} value={n} className="text-neutral-900">
                    {n}
                  </option>
                ))}
              </select>
              <p className="mt-2 text-xs text-pink-200/60">Selected: {neighbour}</p>
            </div>

            {/* Tabs */}
            <nav className="mt-2">
              <div className="grid grid-cols-3 gap-3 overflow-x-auto pb-1">
                {tabs.map((t) => (
                  <button
                    key={t.id}
                    onClick={() => setActiveTab(t.id)}
                    className={`flex-shrink-0 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-all duration-150 
                      ${activeTab === t.id ? "bg-pink-600 text-white shadow-md" : "bg-neutral-800/40 text-pink-200 hover:bg-neutral-800/60"}`}
                    aria-pressed={activeTab === t.id}
                  >
                    {t.label}
                  </button>
                ))}
              </div>
            </nav>
          </header>

          {/* Body */}
          <main className="p-4">
            <section className="mb-4">
              <h2 className="text-xl font-semibold">
                {activeTab === "beauty" && "Beauty services at your doorstep"}
                {activeTab === "revamp" && "Revamp your space — Book expert fixes"}
                {activeTab === "native" && "Native & local services around you"}
              </h2>
              <p className="mt-1 text-sm text-pink-200/60">What are you looking for?</p>

              {/* Search / query input */}
              <div className="mt-3 flex gap-2">
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder={`Search ${activeTab} services — e.g., haircut, painting, tutor`}
                  className="flex-1 rounded-lg border border-pink-700/20 bg-neutral-800/40 py-2 px-3 text-sm placeholder-pink-200/50 focus:outline-none focus:ring-2 focus:ring-pink-400/30"
                />
                <button
                  onClick={() => alert(`Searching for '${query || "anything"}' in ${activeTab}`)}
                  className="rounded-lg w-20 mt-4 px-3 py-2 bg-pink-600 text-white text-sm font-semibold shadow-sm"
                >
                  Search
                </button>
              </div>
            </section>

            {/* Services grid */}
            <section>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {activeServices
                  .filter((s) => s.name.toLowerCase().includes(query.toLowerCase()) || s.short.toLowerCase().includes(query.toLowerCase()))
                  .map((s) => (
                    <article
                      key={s.id}
                      className="rounded-lg bg-neutral-800/40 p-3 flex flex-col gap-2 items-start hover:scale-[1.02] transition-transform"
                    >
                      <div className="text-2xl">{s.emoji}</div>
                      <h3 className="text-sm font-semibold">{s.name}</h3>
                      <p className="text-xs text-pink-200/60">{s.short}</p>
                      <div className="mt-2 w-full flex items-center justify-between">
                        <span className="text-xs text-pink-100/80">From ₹499</span>
                        <button
                          onClick={() => alert(`${s.name} booked in ${neighbour}`)}
                          className="text-xs w-20 bg-pink-600 px-2 py-1 rounded-full font-medium"
                        >
                          Book
                        </button>
                      </div>
                    </article>
                  ))}

                {activeServices.length === 0 && (
                  <div className="col-span-2 text-sm text-pink-200/60">No services found.</div>
                )}
              </div>
            </section>

            {/* Example provider strip */}
            <section className="mt-5">
              <h4 className="text-sm font-semibold">Top professionals nearby</h4>
              <div className="mt-3 space-y-3">
                {[1, 2].map((i) => (
                  <div key={i} className="flex items-center gap-3 bg-neutral-800/30 p-3 rounded-lg">
                    <div className="w-12 h-12 rounded-lg bg-pink-700/20 flex items-center justify-center text-xl">👩‍🔧</div>
                    <div className="flex-1">
                      <div className="text-sm font-medium">Ritu's Studio</div>
                      <div className="text-xs text-pink-200/60">4.8 • 2.1k jobs</div>
                    </div>
                    <div className="text-sm font-semibold text-pink-300">₹799</div>
                  </div>
                ))}
              </div>
            </section>

            {/* CTA */}
            <div className="mt-6 flex flex-row gap-2 items-center justify-center place-items-center">
              <button className="rounded-lg w-32 py-2 bg-pink-600 font-semibold">Book Now</button>
              <button className="rounded-lg w-32 py-2 px-3 border border-pink-700/30">Contact</button>
            </div>
          </main>

          <footer className="p-3 text-center text-xs text-pink-200/50 border-t border-pink-700/10">Powered by Think5Whys</footer>
        </div>

        {/* small helper */}
        {/* <p className="mt-4 text-xs text-pink-200/50">Tip: This is a mobile-first responsive component. Adjust screen width to see layout changes.</p> */}
      </div>
    </div>
  );
}
